import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { joinLinkFor } from '../wf/links';
import { squarespaceDashboard } from '../wf/dashboards';
import ExpandableArea from './ExpandableArea';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Button, ButtonVariant } from "@withfriendsco/wf-components";
import { indiecommerce2Dashboard } from '../wf/dashboards';
import { DiscountScope } from '../types';
const OnlinePopupInstructions = (props) => {
    var _a;
    return (_jsx(React.Fragment, { children: (_a = props.platforms) === null || _a === void 0 ? void 0 : _a.map(p => {
            switch (p.name) {
                case 'INDIECOMMERCE2':
                    return _jsx(Indiecommerce2OnlinePopupInstructions, Object.assign({}, props, { extra: " for IndieCommerce 2.0" }));
                case 'SQUARESPACE':
                    return _jsx(SquarespaceOnlinePopupInstructions, Object.assign({}, props, { extra: " for Squarespace" }));
                case 'TOAST':
                    return _jsx(ToastOnlinePopupInstructions, Object.assign({}, props, { extra: " for Toast" }));
            }
        }).filter(p => !!p).map(p => {
            return (_jsx(ExpandableArea, { title: `Add a popup form or banner ${p === null || p === void 0 ? void 0 : p.props.extra}`, children: p }));
        }) }));
};
const SquarespaceOnlinePopupInstructions = (props) => {
    return (_jsxs("article", { className: "prose max-w-none mt-4 pt-4 border-t-2 mb-2", children: [_jsxs("p", { children: ["From your ", _jsx("a", { href: squarespaceDashboard, target: "_blank", rel: "noopener noreferrer", children: "Squarespace dashboard" }), ", navigate to:"] }), _jsxs("ul", { children: [_jsx("li", { children: "Marketing > Content" }), _jsxs("li", { children: ["Enter this as your Headline: ", _jsxs("strong", { children: ["Support ", props.name] })] }), _jsxs("li", { children: ["Enter this as your Body: ", _jsx("strong", { children: alertDescription(props) })] }), _jsx("li", { children: "Click Save, and visit Marketing > Action" }), _jsx("li", { children: "Select \"Click a Button\"" }), _jsx("li", { children: "Enter \"Learn more\" or \"Become a member\" as the Link Label" }), _jsxs("li", { children: ["Enter this as the link: ", _jsx("strong", { children: joinLinkFor(props.alias, undefined, { "utm_campaign": "wf-website" }) })] })] }), _jsx(CopyToClipboard, { text: joinLinkFor(props.alias, undefined, { "utm_campaign": "wf-website" }), children: _jsx(Button, { className: "my-4", variant: ButtonVariant.Outlined, children: "Copy popup link" }) }), _jsx("ul", { children: _jsx("li", { children: "Click Save" }) })] }));
};
const ToastOnlinePopupInstructions = (props) => {
    return (_jsxs("article", { className: "prose max-w-none mt-4 pt-4 border-t-2 mb-2", children: [_jsx("p", { children: "From your Toast dashboard, navigate to:" }), _jsxs("ul", { children: [_jsx("li", { children: "Other Setup > Online Ordering > Banner message" }), _jsxs("li", { children: ["Enter this as your message: ", _jsx("strong", { children: alertDescription(props) })] }), _jsxs("li", { children: ["Enter this in additional details: ", _jsx("strong", { children: joinLinkFor(props.alias, undefined, { "utm_campaign": "wf-website" }) })] })] }), _jsx(CopyToClipboard, { text: joinLinkFor(alias, undefined, { "utm_campaign": "wf-website" }), children: _jsx(Button, { className: "my-4", variant: ButtonVariant.Outlined, children: "Copy popup link" }) })] }));
};
const deliveryPeriod = (subscriptionBox) => {
    var _a;
    if (!!subscriptionBox.deliveryFrequency && !!((_a = subscriptionBox.shippingFrequency) === null || _a === void 0 ? void 0 : _a.period)) {
        let suffix = (subscriptionBox.deliveryFrequency > 1 ? subscriptionBox.deliveryFrequency + ' ' : '')
            + subscriptionBox.shippingFrequency.period.toLowerCase()
            + (subscriptionBox.deliveryFrequency > 1 ? 's' : '');
        // Handle special cases
        switch (suffix) {
            case "4 quarters":
            case "12 months":
            case "52 weeks":
                suffix = 'year';
                break;
            case "quarter":
            case "3 months":
            case "12 weeks":
            case "13 weeks":
                suffix = '3 months';
                break;
            case "4 weeks":
                suffix = 'month';
                break;
        }
        return suffix;
    }
    else {
        let suffixMap = {
            'annual': 'year',
            'quarterly': '3 months',
            'monthly': 'month',
            'biweekly': '2 weeks',
            'weekly': 'week'
        };
        return suffixMap[subscriptionBox.delivery.toLowerCase()];
    }
};
const alertDescription = (props) => {
    var _a, _b;
    let descriptionParts = [];
    let description = '';
    let intro = '';
    // Benefits
    const subscriptionBox = (_a = props.membershipTiers.find((tier) => !!tier.subscriptionBenefit)) === null || _a === void 0 ? void 0 : _a.subscriptionBenefit;
    if (subscriptionBox) {
        intro = `Become a member! Get a ${subscriptionBox.name.charAt(0).toLowerCase() + subscriptionBox.name.slice(1)} every ${deliveryPeriod(subscriptionBox)}`;
        descriptionParts.push(intro);
    }
    const discount = props.membershipTiers
        .flatMap(tier => tier.discounts)
        .filter(discount => discount.scope === DiscountScope.Retail)
        .reduce((max, discount) => discount.percentage > max.percentage ? discount : max, { percentage: 0, disclaimer: null });
    if (discount) {
        const discountPart = `${intro ? 'plus up to' : 'Get'} ${discount.percentage}% off ${(_b = discount.disclaimer) !== null && _b !== void 0 ? _b : "storewide"}`;
        descriptionParts.push(discountPart);
    }
    descriptionParts.push("and more");
    if (descriptionParts.length > 1) {
        description = descriptionParts.join(", ");
    }
    else {
        description = descriptionParts.join(" ");
    }
    if (!discount && intro) {
        description += "!";
    }
    return description;
};
const Indiecommerce2OnlinePopupInstructions = (props) => {
    return (_jsxs("article", { className: "prose max-w-none mt-4 pt-4 border-t-2 mb-2", children: [_jsxs("p", { children: ["From your ", _jsx("a", { href: props.website ? indiecommerce2Dashboard(props.website) : '#', target: "_blank", rel: "noopener noreferrer", children: "IndieCommerce 2.0 dashboard" }), ", navigate to:"] }), _jsxs("ul", { children: [_jsx("li", { children: "Manage > Site Alerts" }), _jsxs("li", { children: ["Enter this as your Alert text: ", _jsx("strong", { children: alertDescription(props) })] }), _jsxs("li", { children: ["Enter this as the Alert link: ", _jsx("strong", { children: joinLinkFor(props.alias, undefined, { "utm_campaign": "wf-website" }) })] })] }), _jsx(CopyToClipboard, { text: joinLinkFor(props.alias, undefined, { "utm_campaign": "wf-website" }), children: _jsx(Button, { className: "my-4", variant: ButtonVariant.Outlined, children: "Copy popup link" }) })] }));
};
export default OnlinePopupInstructions;
